<template>
  <div class="wrapper">
    <div>
      <input
        type="text"
        :placeholder="label"
        :value="value"
        @input="input"
        @blur="blur"
        :class="{ empty: value.length === 0 }"
      />
      <label>{{ label }}</label>
    </div>
  </div>
</template>

<style scoped>
  .wrapper {
    position: relative;
  }

  .wrapper > div > input {
    height: 5rem;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    font-family: inherit;
    font-size: 1.4rem;
    color: inherit;
    background-color: var(--secondary-background-color);
    border: none;
    border-bottom: 2px solid var(--primary-color);
    border-radius: 3px;
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1);
    outline: none;
    transition-property: border-color, box-shadow;
    transition-duration: 0.3s;
  }

  .wrapper > div > input:focus {
    border-color: var(--secondary-color);
    box-shadow: 0 0 3px 1px rgba(0, 0, 0, 0.1), inset 0 0 2px var(--secondary-color);
  }

  .wrapper > div > input::placeholder {
    color: transparent;
  }

  .wrapper > div > label {
    position: absolute;
    margin: 0;
    top: -1rem;
    left: 0;
    font-size: 1.2rem;
    font-weight: 600;
    line-height: 0;
    pointer-events: none;
    transition-property: top, left;
    transition-duration: 0.3s;
  }

  .wrapper > div > input.empty + label {
    top: 2.5rem;
    left: 2rem;
  }

  .wrapper > div > input:focus + label,
  .wrapper > div > input:-internal-autofill-selected + label {
    top: -1rem;
    left: 0;
  }
</style>

<script>
  export default {
    props: [
      'label',
      'value',
      'input',
      'blur'
    ]
  }
</script>
